import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import { AppState } from 'src/app/reducers'
import { Observable } from 'rxjs'
import { CountableSummary } from 'src/app/models/period-aggregate-amounts.model'
import { getLoading, getUmhpPageviews } from 'src/app/selectors/period-aggregate-amounts.selector'
import { Artist } from 'src/app/models/artist.model'
import { getSelectedArtist } from 'src/app/selectors/artist.selector'
import {
  getDataCollectByUmphPageviews,
  getDataCollectLoading,
} from 'src/app/selectors/data-collections.selector'

@Component({
    selector: 'app-aggregated-amounts-umhp-pageview',
    templateUrl: './aggregated-amounts-umhp-pageview.component.html',
    styleUrls: ['./aggregated-amounts-umhp-pageview.component.scss'],
    standalone: false
})
export class AggregatedAmountsUmhpPageviewComponent implements OnInit {
  umhpPageview$: Observable<CountableSummary>
  selectedArtist$: Observable<Artist>
  loading$: Observable<boolean>

  dataCollections$: Observable<boolean>
  dataCollectLoading$: Observable<boolean>

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.umhpPageview$ = this.store.select(getUmhpPageviews)
    this.selectedArtist$ = this.store.select(getSelectedArtist)
    this.loading$ = this.store.select(getLoading)

    this.dataCollections$ = this.store.select(getDataCollectByUmphPageviews)
    this.dataCollectLoading$ = this.store.select(getDataCollectLoading)
  }
}
